import React from 'react';
import './AppTopBar.scss';
import { connect } from 'react-redux';
import Menu from 'react-ionicons/lib/Menu';
import * as actionCreator from '../../actions/';
import BusinessSwitchIcon from 'react-ionicons/lib/BusinessOutline';
import LogOutIcon from 'react-ionicons/lib/PowerOutline';
import UserAvatar from 'react-ionicons/lib/PersonCircleOutline';
import AppConfig from '../../config/default';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import languageManager from '../../helpers/Language';
import { getCurrentVAccount } from '../../helpers/Session';
import EnvironmentAlert from '../EnvironmentAlert/EnvironmentAlert';
import UserAnalytic from '../../helpers/UserAnalytic';

const ENV = (process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'development');
const TO_FULL_NAME = (up) => (`${up.firstname} ${up.lastname}`);

//const GET_ENTITY_NAME = ({currentVirtualAccount}) => currentVirtualAccount.name;
//const GET_ENTITY_CUSTOMER_CODE = ({currentVirtualAccount}) => currentVirtualAccount.customerCode;

export const DFLT_ICO_PROPS = {
    height: '38px',
    width:  '38px',
    color: 'inherit'
};

export const DFLT_MENU_ICO_PROPS = {
    height: '24px',
    width:  '24px',
    color: 'inherit'
};

const AppTopBar = ({
    profile,
    session,
    pageTitle,
    toggleAppMenuStatus,
    setShowVirtualAccount
}) => {
    const navigateManager = useNavigate();
    const vAccounts = profile._vAccounts;
    const otherVAccounts = profile._othersVAccounts;
    const currentVAccount = getCurrentVAccount(profile, session) || {};
    const hasOtherPortalAccounts = Object.values(otherVAccounts).reduce((memo, current) => memo + current.length, 0);
    const handleSelectVirtualAccount = () => {
        UserAnalytic.event({
            category: 'app_top_bar',
            action: 'Open Switch Business Modal',
        });
        setShowVirtualAccount(true);
    };
    return (
        <div className="app-top-bar shadow-sm">
            <div className="atb-ptitle-box d-md-none" style={{maxWidth: '40px'}}>
                <Menu {...DFLT_ICO_PROPS} onClick={() => toggleAppMenuStatus()}/>
            </div>
            <div className="atb-ptitle-box" style={{'flexGrow': ENV === 'development' ? 0 : 1}}>
                <span className="atb-app-name d-none d-sm-block">{AppConfig.PRODUCT_NAME}</span>
                <span className="atb-ptitle">{pageTitle}</span>
            </div>
            {ENV === 'development' && (<EnvironmentAlert />)}
            <div className="atb-more-info-box d-none d-sm-block" style={{'flexGrow': ENV === 'development' ? 0 : 1}}>
                {currentVAccount &&
                    <DropdownButton
                        title={
                            <span>
                                { currentVAccount?.customerCode }
                                &nbsp;-&nbsp;<span className="fw-bold">{ currentVAccount?.name }</span>
                            </span>
                        }
                        menuVariant="dark"
                    >
                    <Dropdown.Item onClick={() => navigateManager('/settings/access-management') }><UserAvatar {...DFLT_MENU_ICO_PROPS} color="white" /> {languageManager.T('TOP_BAR_MY_ACCOUNT')}</Dropdown.Item>
                    {
                        (vAccounts.length > 1 || hasOtherPortalAccounts > 0) ?
                        <>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={handleSelectVirtualAccount}><BusinessSwitchIcon {...DFLT_MENU_ICO_PROPS} style={{marginRight: 8}} />{languageManager.T('TOP_BAR_MY_SWITCH_ACCOUNT')}</Dropdown.Item>
                        </> : null
                    }
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => navigateManager('/_/leave') } className="text-danger"><LogOutIcon {...DFLT_MENU_ICO_PROPS}/> {languageManager.T('TOP_BAR_MY_LOG_OUT')}</Dropdown.Item>
                </DropdownButton>
            }
            </div>
        </div>
    )
};

const mapStateToProps = (appState) => ({
    profile: appState.userProfile,
    session: appState.session
});

const mapDispatchToProps = (dispatch) => ({
    setShowVirtualAccount: (status) => dispatch(actionCreator.Session.setShowVirtualAccount(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppTopBar);
